import { ApiResponse, OfferingDocument, OfferingDocumentId, OfferingDocumentUploadRequest } from '@arrived/models';

import { api } from './api';
import { buildMultipartFormData, getBlob, unwrapApiResponse } from './utils';

export const getOfferingDocuments = async (offeringId: number) => {
  const response = await api.get<ApiResponse<OfferingDocument[]>>(`/offerings/${offeringId}/documents`);

  return unwrapApiResponse(response.data);
};

// TODO: buildMultipartFormData hasn't been tested
export const uploadOfferingDocument = async (request: OfferingDocumentUploadRequest) => {
  const { body, headers } = buildMultipartFormData<OfferingDocumentUploadRequest>(request);
  const response = await api.post<ApiResponse<OfferingDocument>>(`/offerings/${request.offeringId}/documents`, body, {
    headers,
  });

  return unwrapApiResponse(response.data);
};

export const getOfferingDocument = async (offeringDocumentId: OfferingDocumentId) => {
  const response = await api.get<ApiResponse<OfferingDocument>>(`/offerings/documents/${offeringDocumentId}`);

  return unwrapApiResponse(response.data);
};

export const getOfferingDocumentRaw = async (offeringDocumentId: OfferingDocumentId) => {
  return await getBlob(`/offerings/documents/${offeringDocumentId}/raw`);
};

export const deleteOfferingDocument = async (offeringDocumentId: OfferingDocumentId) => {
  const response = await api.delete<ApiResponse<OfferingDocument>>(`/offerings/documents/${offeringDocumentId}`);

  return unwrapApiResponse(response.data);
};
